<template>
  <Popup
    v-if="isVisible"
    :name="popupName"
    :show-close-button="true"
    :show-delay="0"
    :isModal="true"
    context="shop"
  >
    <template v-slot:title>
      Möchtest du das Paket „{{ booking.article.name }}" wirklich kündigen?
    </template>
    <template v-slot:content>
      <p v-if="energyLinesInBooking > 0">
        Nach der Kündigung hast du insgesamt noch
        {{ remainingEnergyLines }} Energy Line{{
          remainingEnergyLines > 1 ? 's' : ''
        }}
        zur Verfügung.
      </p>
      <p>
        Wenn du dieses Paket jetzt kündigst, wird ab
        {{ formatDate(booking.article.cancellationDate) }} nichts mehr
        verrechnet.
      </p>
      <Alert v-if="bookingError" class="article__error">
        Es gab einen Fehler bei der Kündigung.
      </Alert>
    </template>
    <template v-slot:actions>
      <button class="button button--secondary" @click="onCancelClick">
        Abbrechen
      </button>
      <LinkButton
        :form="formId"
        icon-right="arrow"
        :disableOnSubmit="true"
        @click.native="onCancelBooking"
        text="Kündigen"
        :extra-classes="['button--danger']"
      ></LinkButton>
    </template>
  </Popup>
</template>

<script setup>
  import { computed, watch } from 'vue'
  import Popup from '@/components/popups/Popup.vue'
  import LinkButton from '@/components/LinkButton.vue'
  import Alert from '@/components/Alert.vue'
  import { useShopStore } from '@/stores/useShopStore'
  import { useFormsStore } from '@/stores/useFormsStore'
  import { useCubeStore } from '@/stores/useCubeStore'
  import { useDate } from '@/composables/useDate.ts'
  import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'

  const props = defineProps({
    booking: { type: Object, required: true },
  })

  const popupName = 'cancelArticle'
  const shopStore = useShopStore()
  const formsStore = useFormsStore()
  const cubeStore = useCubeStore()
  const { formatDate } = useDate()
  const formId = `cancel-${props.booking.bookingId}`
  const { hide, isVisible } = useSpecificPopup('cancelArticle')

  const onCancelBooking = async () => {
    formsStore.setFormState(formId, 'submitting')
    await shopStore.cancelBooking(props.booking.bookingId)
    hide()
  }

  const totalEnergyLines = computed(() => cubeStore.totalEnergyLinesAsConsumer)
  const energyLinesInBooking = computed(() => {
    return shopStore.getArticleEnergyLines(props.booking.article.articleId)
  })

  const remainingEnergyLines = computed(() => {
    return totalEnergyLines.value - energyLinesInBooking.value
  })

  const bookingError = computed(() => formsStore.getFormState(formId) === 'error')
  const bookingSuccess = computed(() => formsStore.getFormState(formId) === 'finished')
  watch(bookingSuccess, (newValue) => {
    if (newValue) {
      hide()
    }
  })

  const onCancelClick = () => {
    hide()
  }
</script>
